// Unified, versioned paper-ledger schema. Replaces the ad-hoc ordoMentis_*
// localStorage keys with ONE document under LEDGER_KEY. Legacy ledgers carried
// heterogeneous shapes, so the row types fix the known fields and allow extras.
export const ASSET_CLASSES = [
    'options',
    'daytrade',
    'commodities',
    'forex',
    'crypto',
];
export const LEDGER_VERSION = 2;
export const LEDGER_KEY = 'ordoMentis_ledger_v2';
export function emptyLedger() {
    return {
        version: LEDGER_VERSION,
        trades: { options: [], daytrade: [], commodities: [], forex: [], crypto: [] },
        forecasts: [],
        sandbox: [],
    };
}
// Defensive: ensure every asset bucket exists even if a stored doc is partial.
export function normalize(state) {
    const base = emptyLedger();
    if (!state || typeof state !== 'object')
        return base;
    const trades = (state.trades ?? {});
    for (const asset of ASSET_CLASSES) {
        base.trades[asset] = Array.isArray(trades[asset]) ? trades[asset].slice() : [];
    }
    base.forecasts = Array.isArray(state.forecasts) ? state.forecasts.slice() : [];
    base.sandbox = Array.isArray(state.sandbox) ? state.sandbox.slice() : [];
    if (Array.isArray(state.migratedFrom))
        base.migratedFrom = state.migratedFrom.slice();
    return base;
}
// The ad-hoc keys we consolidate. Trade ledgers map to an asset class; forecasts
// and the sandbox journal are single arrays.
export const LEGACY_TRADE_KEYS = {
    ordoMentis_optionsTrades_v1: 'options',
    ordoMentis_dayTrades_v1: 'daytrade',
    ordoMentis_commodityTrades_v1: 'commodities',
    ordoMentis_forexPaperLog_v1: 'forex',
    ordoCryptoPaperLog: 'crypto',
};
export const LEGACY_FORECAST_KEY = 'ordoMentis_paperForecasts_v1';
export const LEGACY_SANDBOX_KEY = 'sandbox_journal_v1';
//# sourceMappingURL=schema.js.map